import { type FC } from "react";

import { Select } from "@styled/select";

// The report's file name, or a picker when the report has several files. A
// tag can open a file the assistant read that isn't one of them; it joins the
// picker so you can go back.
export const ReportFilePicker: FC<{
  files: ReadonlyArray<{ id: string; name: string }>;
  selectedId: string;
  selectedName?: string;
  onSelect(id: string): void;
}> = ({ files, selectedId, selectedName, onSelect }) => {
  const options = files.some((file) => file.id === selectedId)
    ? files
    : [...files, { id: selectedId, name: selectedName ?? "" }];
  if (options.length < 2) return <>{selectedName}</>;

  return (
    <Select
      value={selectedId}
      onChange={(event) => onSelect(event.target.value)}
      aria-label="Report file"
      variant="sm"
    >
      {options.map((file) => (
        <option key={file.id} value={file.id}>
          {file.name}
        </option>
      ))}
    </Select>
  );
};
